module.exports = __webpack_public_path__ + "img/company2.81dfab45.png";